"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthService = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const config_1 = require("../config/config");
const api_1 = require("./api");
const auth_api_1 = require("./auth-api");
const PATH = '/auth';
class AuthService {
    static async login(body, _) {
        try {
            const api = config_1.react_core_config.internalConfig.gatewayV2 ? auth_api_1.AUTHAPI : api_1.API;
            return await api.post({
                url: `${PATH}/login`,
                body,
                withCredentials: true
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async loginWithToken(body, _) {
        try {
            const api = config_1.react_core_config.internalConfig.gatewayV2 ? auth_api_1.AUTHAPI : api_1.API;
            return await api.post({
                url: `${PATH}/login`,
                body,
                withCredentials: true
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async logout() {
        try {
            const api = config_1.react_core_config.internalConfig.gatewayV2 ? auth_api_1.AUTHAPI : api_1.API;
            return await api.post({
                url: `${PATH}/logout`
            });
        }
        catch (e) {
            throw e;
        }
        finally {
            api_1.API.reset();
        }
    }
    static decodeToken(accessToken) {
        return (0, jwt_decode_1.default)(accessToken);
    }
    static async checkSession() {
        try {
            const api = config_1.react_core_config.internalConfig.gatewayV2 ? auth_api_1.AUTHAPI : api_1.API;
            await api.get({
                url: `${PATH}/check/session`
            });
            return true;
        }
        catch (_a) {
            return false;
        }
    }
    static async loginWithTokenWithProvider(body, provider) {
        try {
            const api = config_1.react_core_config.internalConfig.gatewayV2 ? auth_api_1.AUTHAPI : api_1.API;
            return await api.post({
                url: `${PATH}/login/${provider}`,
                body,
                withCredentials: true
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getPermissions() {
        const api = config_1.react_core_config.internalConfig.gatewayV2 ? auth_api_1.AUTHAPI : api_1.API;
        return api.get({
            url: `${PATH}/check/permissions`
        });
    }
}
exports.AuthService = AuthService;
//# sourceMappingURL=auth-service.js.map